import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'assign-training-modal',
  templateUrl: './assign-training-modal.component.html'
})
export class AssignTrainingModalComponent implements OnInit {
  @Input() siteOwnerId: any;
  @Input() worker: any;
  public availableTrainingCourses: any[] = [];
  public selectedTraining;
  public existingCourses = [];

  constructor(
    private trainingService: TrainingService,
    private activeModal: NgbActiveModal,
    public notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
    this.getExistingCoursesForWorker(this.worker.workerUser.workerUser.id);
    this.getAllSiteInductionsByOwner(this.siteOwnerId);
  }

  private getExistingCoursesForWorker(id) {
    this.trainingService.getWorkerTrainingCourseListById(id).subscribe(data => {
      this.existingCourses = data
        .filter(course => course.course.type === 'TRAINING')
        .filter(course => course.course.siteOwner.id === this.siteOwnerId)
        .map(course => ({
          id: course.workerUserCourseId,
          trainingName: course.course.trainingName,
          courseProgress: course.courseProgress,
          expiryDate: course.expiryDate,
        }));
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load training list data');
    });
  }

  private getAllSiteInductionsByOwner(id) {
    this.availableTrainingCourses = [];
    this.trainingService.getTrainingCoursesBySiteOwnerId(id).subscribe((data: any) => {
      const inductions = data.filter(course => course.courseType === 'TRAINING');

      inductions.forEach(element => {
        const obj = {
          label: element.name,
          value: element.id
        };
        this.availableTrainingCourses.push(obj);
      });
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    const body = {
      courseId: this.selectedTraining.value,
      workerUserId: this.worker.workerUser.workerUser.id,
    };

    this.trainingService.createNewTrainingCourseForWorker(body).subscribe(result => {
      if (this.existingCourses.map(c => c.id).some(id => result.id === id)) {
        this.notificationService.notify('success', 'Success', 'Course already assigned to worker');
      } else {
        this.getExistingCoursesForWorker(this.worker.workerUser.workerUser.id);
        this.notificationService.notify('success', 'Success', 'Course assigned to worker');
      }
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not add course to worker');
    });
  }
}
